import React from "react";
import { useTranslation } from "react-i18next";
import NotificationBanner from "@/components/Common/Banner/NotificationBanner";

interface EmployerMatchThresholdProps {
  employerMatch: number;
  employerContribution: number;
}

const EmployerMatchThreshold: React.FC<EmployerMatchThresholdProps> = ({
  employerMatch,
  employerContribution,
}) => {
  const { t } = useTranslation();
  const showThreshold = employerContribution >= employerMatch;

  return (
    <>
      {showThreshold && (
        <div className="px-[16px] pb-[32px] md:px-[32px]">
          <NotificationBanner
            message={t("onboarding.contributions.employer_match_threshold", {
              percentage: employerMatch,
            })}
            isVisible={true}
          />
        </div>
      )}
    </>
  );
};

export default EmployerMatchThreshold;
